<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>
<div class="container-header"><div class="container-header-inner">
  @if (isLoading) { <app-loading-box></app-loading-box> }
  @else if (documento) { <app-cte-detalhe [notaDetalhe]="documento"></app-cte-detalhe> }
  @else { <h1 class="title-default">CT-e recebido não encontrado</h1> }
</div></div>
